import React, {useEffect, useState} from 'react';
import { Container, Row, Col, Form, Spinner, Modal, Alert, Table} from 'react-bootstrap';
import { MdSearch, MdHouse, MdShoppingBag} from 'react-icons/md'

function Search(){
   return(
      <div className='search-bar flex'>
        <div className='flex three input-box'></div>
        <div className='flex one search-box center'>
             <MdSearch size={25} className='brown'/>
        </div>
      </div>
   )
}

export default Search